<template>
  <div class="min-h-screen flex items-center justify-center bg-white px-4">
    <div class="max-w-md w-full text-center">
      <!-- Icon -->
      <div class="w-16 h-16 mx-auto mb-6 bg-stone-100 flex items-center justify-center">
        <svg v-if="code === '404'" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <svg v-else-if="code === '500'" xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <!-- Error Code -->
      <p class="text-xs uppercase tracking-[0.3em] text-gray-500 mb-2">{{ $t('error.code', { code }) }}</p>

      <!-- Title -->
      <h1 class="text-2xl md:text-3xl font-light text-gray-900 mb-4">
        {{ title }}
      </h1>

      <!-- Message -->
      <p class="text-gray-600 text-sm mb-8">
        {{ message }}
      </p>

      <!-- Action -->
      <router-link 
        to="/" 
        class="inline-flex items-center justify-center px-6 py-3 bg-gray-900 text-white text-sm font-medium tracking-wide hover:bg-gray-800 transition-colors"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
        {{ $t('error.go_home') }}
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'

const route = useRoute()
const { t } = useI18n()

const code = computed(() => (route.params.code as string) || '404')

const title = computed(() => {
  const key = `error.titles.${code.value}`
  const translated = t(key)
  // If translation not found (returns the key itself), fall back to default
  if (translated === key) {
    return t('error.titles.default')
  }
  return translated
})

const message = computed(() => {
  const key = `error.messages.${code.value}`
  const translated = t(key)
  // If translation not found (returns the key itself), fall back to default
  if (translated === key) {
    return t('error.messages.default')
  }
  return translated
})
</script>
